import { render } from "./PageMyBots.vue?vue&type=template&id=6f4dc537&scoped=true"
import script from "./PageMyBots.vue?vue&type=script&lang=js"
export * from "./PageMyBots.vue?vue&type=script&lang=js"

import "./PageMyBots.vue?vue&type=style&index=0&id=6f4dc537&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4dc537"]])

export default __exports__